import React from "react";
import "./policy.css";
import { Link } from "react-router-dom";

function CookiePolicy() {
  return (
    <div style={{ backgroundColor: "#00a3bb" }}>
      <div
        className="text-center pb-1 pt-3"
        style={{ textAlign: "center", paddingTop: "25px" }}
      >
        <Link to="/">
          <img
            src="../assets/Virtual Triage.png"
            alt="Virtual Triage Cookie Policy"
            style={{ width: "150px" }}
          />
        </Link>
      </div>
      <div className="content">
        <div className="Practitionersbox">
          <h2 className="text-white text-center" style={{ color: "#00a3bb !important" }}>
            Cookie Policy for Virtual Triage
          </h2>
          <p className="pt-3 pb-3">
            This Cookie Policy explains how Virtual Triage ("we," "us," or "our") uses cookies and similar tracking technologies when you visit our website at virtualtriage.ai and use our mobile applications. We are committed to being transparent about how we collect and use your data.
          </p>
          
          <hr />
          <h1 className="pt-3 pph1">What Are Cookies?</h1>
          <hr />
          
          <p>
            Cookies are small text files that are placed on your device (computer, smartphone, or tablet) when you visit our website. They help us provide you with a better experience by remembering your preferences and improving our services.
          </p>
          
          <h3>Types of Cookies We Use</h3>
          
          <h4>1. Essential Cookies</h4>
          <p>These cookies are necessary for our website to function properly and cannot be disabled. They include:</p>
          <ul>
            <li><strong>Session Management:</strong> Keep you logged in during your visit</li>
            <li><strong>Security:</strong> Protect against fraudulent activity and ensure secure connections</li>
            <li><strong>Load Balancing:</strong> Distribute website traffic efficiently</li>
            <li><strong>Form Data:</strong> Remember information you've entered in forms</li>
          </ul>
          
          <h4>2. Performance and Analytics Cookies</h4>
          <p>These cookies help us understand how visitors use our website so we can improve it:</p>
          <ul>
            <li><strong>Google Analytics:</strong> Track website usage, popular pages, and user behavior</li>
            <li><strong>Page Load Times:</strong> Monitor website performance and loading speeds</li>
            <li><strong>Error Tracking:</strong> Identify and fix technical issues</li>
            <li><strong>User Flow Analysis:</strong> Understand how users navigate through our platform</li>
          </ul>
          
          <h4>3. Functional Cookies</h4>
          <p>These cookies enhance your experience by remembering your choices:</p>
          <ul>
            <li><strong>Language Preferences:</strong> Remember your selected language</li>
            <li><strong>Location Settings:</strong> Store your preferred location for finding practitioners</li>
            <li><strong>Accessibility Settings:</strong> Remember your accessibility preferences</li>
            <li><strong>Theme Preferences:</strong> Save your display preferences</li>
          </ul>
          
          <h4>4. Marketing and Advertising Cookies</h4>
          <p>These cookies are used to show you relevant advertisements:</p>
          <ul>
            <li><strong>Google Ads:</strong> Show relevant healthcare-related advertisements</li>
            <li><strong>Social Media Integration:</strong> Enable sharing on social platforms</li>
            <li><strong>Remarketing:</strong> Show you our ads on other websites you visit</li>
            <li><strong>Campaign Tracking:</strong> Measure the effectiveness of our marketing campaigns</li>
          </ul>
          
          <hr />
          <h1 className="pt-3 pph1">Third-Party Cookies</h1>
          <hr />
          
          <p>We work with trusted third-party services that may place cookies on your device:</p>
          
          <h3>Google Services</h3>
          <ul>
            <li><strong>Google Analytics:</strong> Website traffic analysis and user behavior insights</li>
            <li><strong>Google Tag Manager:</strong> Managing marketing and analytics tags</li>
            <li><strong>Google Maps:</strong> Location services for finding nearby practitioners</li>
            <li><strong>Google Ads:</strong> Targeted advertising and remarketing</li>
          </ul>
          
          <h3>Payment Processing</h3>
          <ul>
            <li><strong>Stripe:</strong> Secure payment processing for consultations and subscriptions</li>
            <li><strong>PayPal:</strong> Alternative payment methods (if applicable)</li>
          </ul>
          
          <h3>Communication Tools</h3>
          <ul>
            <li><strong>Video Calling Services:</strong> Enable secure video consultations</li>
            <li><strong>Email Services:</strong> Send appointment confirmations and notifications</li>
            <li><strong>SMS Services:</strong> Send appointment reminders and updates</li>
          </ul>
          
          <h3>Social Media</h3>
          <ul>
            <li><strong>Facebook:</strong> Social login and sharing features</li>
            <li><strong>LinkedIn:</strong> Professional networking integration</li>
            <li><strong>Twitter:</strong> Social sharing capabilities</li>
          </ul>
          
          <hr />
          <h1 className="pt-3 pph1">Managing Your Cookie Preferences</h1>
          <hr />
          
          <h3>Browser Settings</h3>
          <p>You can control cookies through your browser settings:</p>
          <ul>
            <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies and other site data</li>
            <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
            <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
            <li><strong>Edge:</strong> Settings → Cookies and site permissions → Cookies and site data</li>
          </ul>
          
          <h3>Opt-Out Options</h3>
          <p>You can opt out of specific tracking services:</p>
          <ul>
            <li><strong>Google Analytics:</strong> Install the Google Analytics Opt-out Browser Add-on</li>
            <li><strong>Google Ads:</strong> Visit Google Ads Settings to control personalized advertising</li>
            <li><strong>Facebook:</strong> Adjust your Facebook advertising preferences</li>
          </ul>
          
          <h3>Mobile App Settings</h3>
          <p>In our mobile app, you can manage tracking preferences through:</p>
          <ul>
            <li>App Settings → Privacy & Data</li>
            <li>Device Settings → App Permissions</li>
            <li>Advertising ID settings on your device</li>
          </ul>
          
          <hr />
          <h1 className="pt-3 pph1">Cookie Consent</h1>
          <hr />
          
          <p>
            When you first visit our website, we'll ask for your consent to use non-essential cookies. You can:
          </p>
          <ul>
            <li><strong>Accept All:</strong> Allow all cookies for the best experience</li>
            <li><strong>Manage Preferences:</strong> Choose which types of cookies to allow</li>
            <li><strong>Reject Non-Essential:</strong> Only allow essential cookies</li>
          </ul>
          
          <p>
            You can change your cookie preferences at any time by clicking the "Cookie Settings" link in our website footer or by clearing your browser cookies.
          </p>
          
          <hr />
          <h1 className="pt-3 pph1">Data Retention</h1>
          <hr />
          
          <p>We retain cookie data for different periods depending on the type:</p>
          <ul>
            <li><strong>Session Cookies:</strong> Deleted when you close your browser</li>
            <li><strong>Functional Cookies:</strong> Stored for up to 1 year</li>
            <li><strong>Analytics Cookies:</strong> Stored for up to 2 years</li>
            <li><strong>Marketing Cookies:</strong> Stored for up to 1 year</li>
          </ul>
          
          <hr />
          <h1 className="pt-3 pph1">Healthcare Data Protection</h1>
          <hr />
          
          <p>
            As a healthcare platform, we take extra care with your data:
          </p>
          <ul>
            <li><strong>HIPAA Compliance:</strong> We ensure cookies don't expose protected health information</li>
            <li><strong>GDPR Compliance:</strong> We follow European data protection regulations</li>
            <li><strong>Encryption:</strong> All cookie data is encrypted during transmission</li>
            <li><strong>Access Controls:</strong> Strict controls on who can access cookie data</li>
          </ul>
          
          <hr />
          <h1 className="pt-3 pph1">Updates to This Cookie Policy</h1>
          <hr />
          
          <p>
            We may update this Cookie Policy to reflect changes in our practices or legal requirements. We will notify you of significant changes through:
          </p>
          <ul>
            <li>Email notifications to registered users</li>
            <li>In-app notifications</li>
            <li>Website banners</li>
            <li>Updated policy links on our website</li>
          </ul>
          
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
          
          <hr />
          <h1 className="pt-3 pph1">Contact Us</h1>
          <hr />
          
          <p>
            If you have questions about our use of cookies or this Cookie Policy, please contact us:
          </p>
          <ul>
            <li><strong>Email:</strong> teams@virtualtriage.ai</li>
            {/* <li><strong>Data Protection Officer:</strong> dpo@virtualtriage.ai</li> */}
            <li><strong>Website:</strong> virtualtriage.ai</li>
            <li><strong>Address:</strong> 50 John Street M5V 3T5, Toronto, ON, Canada</li>
          </ul>
          
          <div style={{ marginTop: "30px", padding: "20px", backgroundColor: "#f8f9fa", borderRadius: "5px", border: "1px solid #dee2e6" }}>
            <h4 style={{ color: "#00a3bb", marginBottom: "15px" }}>Quick Actions</h4>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Link to="/policy" style={{ textDecoration: "none" }}>
                <button style={{ padding: "10px 20px", backgroundColor: "#00a3bb", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                  View Privacy Policy
                </button>
              </Link>
              <button 
                onClick={() => {
                  // This would open cookie settings if implemented
                  alert("Cookie settings panel would open here. You can implement a cookie consent management platform.");
                }}
                style={{ padding: "10px 20px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}
              >
                Manage Cookie Settings
              </button>
              <Link to="/" style={{ textDecoration: "none" }}>
                <button style={{ padding: "10px 20px", backgroundColor: "#6c757d", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                  Back to Home
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy; 